module.exports = __webpack_public_path__ + "static/media/contract-icon.13f0c613.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/contract-icon.svg
// module id = 3264
// module chunks = 0